import { LeaderboardManagement, useTheme } from '@e-learning/shared';
import { useTranslation } from 'react-i18next';
import { useLeaderboardDashboard } from './hooks';

export default function LeaderboardPage() {
  const theme = useTheme();
  const { t } = useTranslation('common');
  const lb = theme.palette.adminLeaderboard;

  const {
    stats,
    rows,
    total,
    loading,
    page,
    pageSize,
    onPageChange,
    search,
    setSearch,
  } = useLeaderboardDashboard();

  return (
    <div
      style={{
        width: '100%',
        minWidth: 0,
        height: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          boxSizing: 'border-box',
          width: '100%',
          minWidth: 0,
          minHeight: '100%',
          backgroundColor: lb.pageBackground,
          padding: theme.spacing.xl,
        }}
      >
        <h1
          style={{
            marginBottom: theme.spacing.xs,
            fontWeight: theme.typography.fontWeight.semibold,
            color: theme.palette.text.primary,
            fontSize: theme.typography.fontSize['2xl'],
          }}
        >
          {t('leaderboard.title')}
        </h1>
        <p
          style={{
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing.xl,
            fontSize: theme.typography.fontSize.base,
          }}
        >
          {t('leaderboard.subtitle')}
        </p>

        <LeaderboardManagement
          omitPageShell
          stats={stats}
          rows={rows}
          loading={loading}
          searchValue={search}
          onSearchChange={setSearch}
          pagination={{
            totalRecords: total,
            page,
            pageSize,
            onPageChange,
          }}
        />
      </div>
    </div>
  );
}
